"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JumpledStrings = void 0;
const drag_and_drop_card_1 = require("./drag-and-drop-card");
class JumpledStrings {
    constructor(id) {
        this.jumpledStrings = document.createElement('div');
        this.jumpledStrings.id = id;
        this.jumpledStrings.className = id;
    }
    render(str) {
        JumpledStrings.currentString = str;
        str
            .split(' ')
            .sort(() => Math.random() - 0.5)
            .forEach((word) => {
            const wordP = document.createElement('p');
            wordP.className = 'word-p';
            wordP.id = 'word-p';
            wordP.innerText = word;
            wordP.draggable = true;
            this.jumpledStrings.append(wordP);
            wordP.addEventListener('dragstart', drag_and_drop_card_1.dragCards);
            wordP.addEventListener('mouseup', drag_and_drop_card_1.clickCards);
            wordP.addEventListener('dragend', drag_and_drop_card_1.dropCards);
        });
        return this.jumpledStrings;
    }
}
exports.JumpledStrings = JumpledStrings;
JumpledStrings.currentString = '';
